import { motion } from "framer-motion";

const LOGO_URL = "./img/knots-logo.png";

const IntroScreen = ({ onOpen, isHidden }) => {
  return (
    <motion.div
      initial={{ opacity: 1 }}
      animate={{ opacity: isHidden ? 0 : 1 }}
      transition={{ duration: 0.8 }}
      className={`intro-overlay ${isHidden ? "hidden" : ""}`}
      data-testid="intro-screen"
    >
      {/* Decorative Pattern Background */}
      <div className="chinese-pattern" />

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center px-4 sm:px-6 text-center w-full max-w-lg mx-auto">
        {/* Logo */}
        <motion.div
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="mb-6 sm:mb-8"
        >
          <img
            src={LOGO_URL}
            alt="KNOTS Wedding Organizer"
            className="w-24 sm:w-32 md:w-30 h-auto"
            style={{
              filter: "drop-shadow(0 4px 12px rgba(212, 175, 55, 0.3))",
            }}
            data-testid="intro-logo"
          />
        </motion.div>

        {/* Decorative Line */}
        <motion.div
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="w-16 sm:w-24 h-px bg-[#D4AF37] mb-6 sm:mb-8"
        />

        {/* Invitation Text */}
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="font-serif-accent text-[10px] sm:text-xs md:text-sm tracking-[0.2em] sm:tracking-[0.3em] text-[#5A5A5A] uppercase mb-3 sm:mb-4"
        >
          The Sangjit Ceremony of
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="font-serif-heading text-3xl sm:text-4xl md:text-6xl text-[#8B0000] mb-3 sm:mb-4"
        >
          Michelle & Kevin
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.7 }}
          className="font-serif-accent text-[10px] sm:text-xs md:text-sm tracking-[0.15em] sm:tracking-[0.2em] text-[#D4AF37] uppercase mb-8 sm:mb-12"
        >
          You Are Cordially Invited
        </motion.p>

        {/* Open Button */}
        <motion.button
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.8 }}
          onClick={onOpen}
          className="open-button pulse-gold text-xs sm:text-sm"
          data-testid="open-invitation-btn"
        >
          Open Invitation
        </motion.button>

        {/* Scroll Hint */}
        {/* <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 1 }}
          className="absolute bottom-6 sm:bottom-8 left-1/2 -translate-x-1/2"
        >
          <div className="flex flex-col items-center">
            <motion.div
              animate={{ y: [0, 8, 0] }}
              transition={{ duration: 1.5, repeat: Infinity }}
              className="w-4 h-6 sm:w-5 sm:h-8 border-2 border-[#D4AF37] rounded-full flex justify-center pt-1"
            >
              <div className="w-0.5 sm:w-1 h-1.5 sm:h-2 bg-[#D4AF37] rounded-full" />
            </motion.div>
          </div>
        </motion.div> */}
      </div>

      {/* Corner Decorations - smaller on mobile */}
      <div className="absolute top-4 left-4 sm:top-6 sm:left-6 w-10 h-10 sm:w-16 sm:h-16 border-l-2 border-t-2 border-[#D4AF37] opacity-50" />
      <div className="absolute top-4 right-4 sm:top-6 sm:right-6 w-10 h-10 sm:w-16 sm:h-16 border-r-2 border-t-2 border-[#D4AF37] opacity-50" />
      <div className="absolute bottom-4 left-4 sm:bottom-6 sm:left-6 w-10 h-10 sm:w-16 sm:h-16 border-l-2 border-b-2 border-[#D4AF37] opacity-50" />
      <div className="absolute bottom-4 right-4 sm:bottom-6 sm:right-6 w-10 h-10 sm:w-16 sm:h-16 border-r-2 border-b-2 border-[#D4AF37] opacity-50" />
    </motion.div>
  );
};

export default IntroScreen;
